<template>
  <div>
    <div class="panel-main-content-height">
      <header class="page-header page-header-collapsed">
        <div class="page-title-wrapper">
          <a class="button button--icon -inverse previous-panel has-tooltip" id="tooltip-back" @click="$emit('back')">
            <i class="isax isax-arrow-left"></i>
          </a>
          <b-tooltip target="tooltip-back" triggers="hover">
            {{ $t("sessions.reports.backward") }}
          </b-tooltip>
          <h1 class="page-title">{{ $t("sessions.gradeattendancemodal.seedetailstitle") }}</h1>
        </div>
        <button class="bb-close" v-on:click="$emit('hide')">
          <span>{{ $t("buttons.close") }}</span><i class="isax isax-close-circle"/>
        </button>
      </header>
      <div id="body-content" class="body-content instances-container overflow-auto">
        <table class="content-table report-table">
          <tbody>
            <tr class="content-table__header content-table__header--shadow">
              <th>{{ $t("sessions.gradeattendancemodal.reports.date") }}</th>
              <th>{{ $t("sessions.name") }}</th>
              <th>{{ $t("sessions.reports.assistance") }}</th>
              <th>{{ $t("sessions.gradeattendancemodal.pregrade.grade") }}</th>
            </tr>
            <tr v-for="attendee_report in paginated_attendee_reports_detail" v-bind:key="attendee_report.classroomId" class="element-list-row" bb-attendance-instance-row>
              <td class="date">
                <span>{{ attendee_report.classroomStart | moment("DD/MM/YY - HH:mm") }}</span>
              </td>
              <td>
                <span>{{ attendee_report.classroomName }}</span>
              </td>
              <td>
                <span>{{ $t("sessions.gradeattendancemodal.pregrade." + (attendee_report.attendanceQualified ? "qualified" : "notqualified")) }}</span>
              </td>
              <td>
                <span>{{ attendee_report.attendanceGrades.grade }}%</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-center">
        <b-pagination
          v-if="attendee_reports_detail_rows > attendee_reports_detail_pagination.limit"
          v-model="attendee_reports_detail_pagination.currentPage"
          :total-rows="attendee_reports_detail_rows"
          :per-page="attendee_reports_detail_pagination.limit"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import CloseIcon from 'vue-material-design-icons/Close.vue'
import KeyboardReturnIcon from 'vue-material-design-icons/KeyboardReturn.vue'
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue'
import ChevronUpIcon from 'vue-material-design-icons/ChevronUp.vue'
import ChevronRightIcon from 'vue-material-design-icons/ChevronRight.vue'
import jwtMixin from '../../../mixins/jwtMixin'
import utilitiesMixin from '../../../mixins/utilitiesMixin'

export default {
  name: 'DetailGrade',
  components: {CloseIcon, KeyboardReturnIcon, ChevronDownIcon, ChevronUpIcon, ChevronRightIcon},
  mixins: [jwtMixin, utilitiesMixin],
  props: ['classrooms', 'gradable_activities', 'selected', 'attendee_reports_detail'],
  mounted () {
    this.$moment.locale('es')
  },
  created () {
    this.$i18n.locale = this.jwtLanguage()
  },
  data () {
    return {
      attendee_reports_detail_pagination: {
        limit: 10,
        currentPage: 1
      },
      sortActive: true,
      sortOrder: 'desc'
    }
  },
  computed: {
    attendee_reports_detail_rows () {
      return this.attendee_reports_detail.length
    },
    sorted_attendee_reports_detail () {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.attendee_reports_detail.sort((a, b) => new Date(b.classroomStart) - new Date(a.classroomStart))
    },
    paginated_attendee_reports_detail () {
      let start = (this.attendee_reports_detail_pagination.currentPage - 1) * this.attendee_reports_detail_pagination.limit
      let end = start + this.attendee_reports_detail_pagination.limit
      return this.sorted_attendee_reports_detail.slice(start, end)
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Lti/SessionsModals/DetailGrade.vue